import React from 'react';
import { PopUpNotification } from 'extracted-chat-components';

import {
  ButtonColor,
  ButtonShape,
  ButtonSize,
} from 'constants/enums';

const AllPsychicMuted = ({
  isNotificationPopUp,
  popUpNotificationData,
  isRequestError,
  showPopUpNotification,
  removePopUpNotification,
}) => {
  const handleAcceptButton = () => {
    showPopUpNotification(false);
    removePopUpNotification();
  };

  const acceptButton = {
    text: 'Okay',
    color: ButtonColor.WARNING,
    size: ButtonSize.XS,
    shape: ButtonShape.ROUNDED,
    handler: handleAcceptButton,
  };

  return (
    <PopUpNotification
      isRequestError={isRequestError}
      isOpen={isNotificationPopUp}
      description={popUpNotificationData.description}
      title={popUpNotificationData.title}
      acceptButton={acceptButton}
      isBigWidth={false}
    />
  );
};

export default AllPsychicMuted;
